export default __webpack_public_path__ + "static/media/grafema_ciceco_01.a2cc1f1e.mp4";